import { ManejoFCA } from "@/mocks/fca";

interface Props {
  manejo: ManejoFCA;
}

const prioridadeConfig: Record<string, { badge: string; label: string }> = {
  "Baixa": { badge: "bg-primary-100 text-primary-700", label: "Baixa" },
  "Média": { badge: "bg-caution-100 text-caution-700", label: "Média" },
  "Alta": { badge: "bg-warning-100 text-warning-700", label: "Alta" },
  "Crítica": { badge: "bg-danger-100 text-danger-700", label: "Crítica" },
  "Emergencial": { badge: "bg-danger-100 text-danger-700", label: "Emergencial" },
};

const statusManejoConfig: Record<string, { badge: string; label: string }> = {
  recomendado: { badge: "bg-accent-100 text-accent-700", label: "Recomendado" },
  solicitado: { badge: "bg-caution-100 text-caution-700", label: "Solicitado" },
  autorizado: { badge: "bg-primary-100 text-primary-700", label: "Autorizado" },
  executado: { badge: "bg-primary-100 text-primary-700", label: "Executado" },
  concluido: { badge: "bg-background-200 text-foreground-600", label: "Concluído" },
  Executado: { badge: "bg-primary-100 text-primary-700", label: "Executado" },
};

export default function TreeManagementPanel({ manejo }: Props) {
  const formatDate = (dateStr: string) => {
    const [y, m, d] = dateStr.split("-");
    return `${d}/${m}/${y}`;
  };

  const prioridade = prioridadeConfig[manejo.prioridade] || { badge: "", label: manejo.prioridade };
  const status = statusManejoConfig[manejo.status] || { badge: "", label: manejo.status };

  return (
    <div className="space-y-5">
      {/* Current recommendation */}
      <div className="bg-white rounded-card border border-background-200/70 p-5">
        <h3 className="text-sm font-semibold text-foreground-900 font-heading mb-4 flex items-center gap-2">
          <i className="ri-tools-line text-primary-500"></i>
          Recomendação Atual
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <div>
            <p className="text-[11px] text-foreground-500 uppercase tracking-wide mb-1">Recomendação</p>
            <p className="text-sm font-semibold text-foreground-900">{manejo.recomendacaoAtual}</p>
          </div>
          <div>
            <p className="text-[11px] text-foreground-500 uppercase tracking-wide mb-1">Prioridade</p>
            <span className={`badge ${prioridade.badge}`}>{prioridade.label}</span>
          </div>
          <div>
            <p className="text-[11px] text-foreground-500 uppercase tracking-wide mb-1">Status</p>
            <span className={`badge ${status.badge}`}>{status.label}</span>
          </div>
        </div>
        <div className="p-3 bg-background-50 rounded-lg border border-background-200/70 mb-4">
          <p className="text-[11px] text-foreground-500 uppercase tracking-wide mb-1">Justificativa Técnica</p>
          <p className="text-sm text-foreground-700 leading-relaxed">{manejo.justificativa}</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <button className="btn-primary text-xs">
            <i className="ri-send-plane-line"></i>
            Solicitar manejo
          </button>
          <button className="btn-outline text-xs">
            <i className="ri-check-double-line"></i>
            Registrar execução
          </button>
        </div>
      </div>

      {/* History */}
      <div className="bg-white rounded-card border border-background-200/70 overflow-hidden">
        <div className="p-5 pb-3">
          <h3 className="text-sm font-semibold text-foreground-900 font-heading flex items-center gap-2">
            <i className="ri-history-line text-foreground-600"></i>
            Histórico de Manejo
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200 bg-background-50">
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Data</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Tipo</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Status</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Técnico</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Descrição</th>
              </tr>
            </thead>
            <tbody>
              {manejo.historico.map((h) => {
                const st = statusManejoConfig[h.status] || { badge: "", label: h.status };
                return (
                  <tr key={h.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                    <td className="px-4 py-3 text-sm text-foreground-900 font-medium whitespace-nowrap">{formatDate(h.data)}</td>
                    <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{h.tipo}</td>
                    <td className="px-4 py-3 whitespace-nowrap"><span className={`badge ${st.badge}`}>{st.label}</span></td>
                    <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{h.tecnico}</td>
                    <td className="px-4 py-3 text-sm text-foreground-600 max-w-[280px] truncate">{h.descricao}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}